console.log('Vite ⚡️ Rails');

// turbo
import * as Turbo from '@hotwired/turbo';
Turbo.start();

// turbo rails
import '@hotwired/turbo-rails';

// stimulus
import '../controllers';


const countDownClock = (targetDate) => {
  const d = document;
  const daysElement = d.querySelector('.days');
  const hoursElement = d.querySelector('.hours');
  const minutesElement = d.querySelector('.minutes');
  const secondsElement = d.querySelector('.seconds');
  let countdown;

  const targetTime = new Date(targetDate).getTime();
  const now = Date.now();
  const secondsUntil = Math.floor((targetTime - now) / 1000);

  if (secondsUntil <= 0) {
    displayTimeLeft(0);
    return;
  }

  timer(secondsUntil);

  function timer(seconds) {
    const now = Date.now();
    const then = now + seconds * 1000;

    countdown = setInterval(() => {
      const secondsLeft = Math.round((then - Date.now()) / 1000);

      if (secondsLeft <= 0) {
        clearInterval(countdown);
        displayTimeLeft(0);
        return;
      }

      displayTimeLeft(secondsLeft);
    }, 1000);
  }

  function displayTimeLeft(seconds) {
    daysElement.textContent = Math.floor(seconds / 86400);
    hoursElement.textContent = Math.floor((seconds % 86400) / 3600);
    minutesElement.textContent = Math.floor((seconds % 3600) / 60);
    secondsElement.textContent = seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60;
  }
};

// Auto-init: read from <div class="ticker" data-ticker-time="2025-06-16T15:00:00">
document.addEventListener('DOMContentLoaded', () => {
  const ticker = document.querySelector('.ticker');
  if (ticker && ticker.dataset.tickerTime) {
    countDownClock(ticker.dataset.tickerTime);
  }
});
